export const STEPS = {
  Tickets: 1,
  Addons: 2,
  Checkout: 3,
};
